import React from 'react';
import Container from '../Container';
import Subtitle from '../Subtitle';
import T from 'i18n-react';
import BorderBox from '../BorderBox';
import PlanContext from '../context';
import PlanTermAccordion from './PlanTermAccordion';

const PlanTermContainer = () => {
  const {
    plan: { terms },
    version,
    loaded,
    readOnly,
  } = React.useContext(PlanContext);

  return (
    <Container>
      <Subtitle>{T.translate('plan.termSubtitle')}</Subtitle>
      <BorderBox>
        {loaded ? (
          terms.map((props, index) => (
            <PlanTermAccordion
              {...props}
              index={index}
              key={`${version}-${props.id ? `planId-${props.id}` : index}`}
              readOnly={readOnly}
            />
          ))
        ) : (
          <PlanTermAccordion index={0} skeleton />
        )}
      </BorderBox>
    </Container>
  );
};

export default PlanTermContainer;
